<template>
  <v-app
    light
    :style="myAppStyle"
  >
    <page-header />
    <v-content>
      <v-container fluid>
        <transition
          name="page"
          mode="out-in"
        >
          <router-view />
        </transition>
      </v-container>
    </v-content>
    <full-loading />
    <feedback-message />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '~/components/PageHeader'
import FeedbackMessage from '~/components/FeedbackMessage'
import FullLoading from '~/components/FullLoading'

export default {
  name: 'default-layout',
  components: {
    'page-header': PageHeader,
    'feedback-message': FeedbackMessage,
    'full-loading': FullLoading
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    myAppStyle () {
      if (this.$route.name !== 'outlets') {
        return {
          backgroundColor: this.theme.login_bg_color
        }
      }
    }
  },
  mounted () {
    this.$bus.$emit('refreshFontName', this.theme.font)
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue